import React from 'react';

// Modal component to display content conditionally based on `show` and `type` props
const Modal = ({ children, show, type }) => {
  // Determine the modal's class based on `type` and `show` props:
  // - If `type` is "warn" and `show` is true, apply `warn-modal` styling.
  // - If `show` is true and `type` is not "warn," apply `modal d-block` for display.
  // - If `show` is false, apply `modal d-none` to hide the modal.
  const modalClass = type === "warn" && show ? 'warn-modal' : show ? 'modal d-block' : 'modal d-none';

  return (
    <div className={modalClass}>
      {children} {/* Renders the content passed inside the Modal component */}
    </div>
  );
};

export default Modal;
